import { render, staticRenderFns } from "./Episode_tvshow.vue?vue&type=template&id=c8727d26&"
import script from "./Episode_tvshow.vue?vue&type=script&lang=js&"
export * from "./Episode_tvshow.vue?vue&type=script&lang=js&"
import style0 from "./Episode_tvshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8727d26')) {
      api.createRecord('c8727d26', component.options)
    } else {
      api.reload('c8727d26', component.options)
    }
    module.hot.accept("./Episode_tvshow.vue?vue&type=template&id=c8727d26&", function () {
      api.rerender('c8727d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/Episode_tvshow.vue"
export default component.exports